import styled from 'styled-components/macro';
import { Button } from '@yme/atoms/button';
import { RadioButton } from '@yme/atoms/radio-button';
import { colorCoreBlack300, colorCoreBlack900Base, colorCoreGray500, colorCoreWhite1000, } from '@yme/tokens/colors';
import { CORNER_RADIUS } from '@yme/tokens/cornerRadius';
import { ADAPTIVE } from '@yme/tokens/screen';
import { HeadingLevel3, RegularTextLevel3 } from '@yme/tokens/typography';
import { getTextStyles } from '@yme/utils/styles';
export const ButtonStyled = styled(Button) `
  width: auto;
`;
export const PaginationText = styled.span `
  ${getTextStyles('Ubuntu', 400, 14, 20)};

  white-space: nowrap;
`;
export const ContainerStyled = styled.div `
  background-color: ${colorCoreWhite1000};
`;
export const HeaderContainerStyled = styled.div `
  margin-bottom: 24px;

  ${ADAPTIVE.minWidth.desktop} {
    margin-bottom: 24px;
  }
`;
export const HeaderTitleStyled = styled(HeadingLevel3) `
  font-size: 24px;
`;
export const HeaderSubtitleStyled = styled(RegularTextLevel3) `
  margin-top: 8px;
  color: ${colorCoreBlack300};
`;
export const InputContainerStyled = styled.div `
  margin-bottom: 24px;
`;
export const TableHeaderStyled = styled.th `
  ${getTextStyles('Ubuntu', 400, 14, 20)}
  ${({ isRightToLeft }) => (isRightToLeft ? 'margin-left: 24px;' : 'margin-right: 24px;')}

  color: ${colorCoreBlack300};

  display: flex;
  align-items: flex-start;
`;
export const TableLabelStyled = styled.th `
  ${getTextStyles('Ubuntu', 400, 14, 20)}

  color: ${colorCoreBlack900Base};
  word-break: break-word;
`;
export const RadioButtonGroup = styled.div `
  ${({ hasContent }) => hasContent && `border: 1px solid ${colorCoreGray500};`}

  border-radius: ${CORNER_RADIUS.s};
`;
export const RadioButtonStyled = styled(RadioButton) `
  padding: 18px 16px;

  &:not(:last-child) {
    border-bottom: 1px solid ${colorCoreGray500};
  }
`;
export const DealerDataStyled = styled.table `
  text-align: ${({ isRightToLeft }) => (isRightToLeft ? 'right' : 'left')};

  border-spacing: 0;

  th {
    padding-bottom: 8px;
  }
`;
export const ApplySelectionButton = styled(Button) `
  width: 100%;

  order: -1;
  ${ADAPTIVE.minWidth.tablet} {
    width: auto;
    order: 0;
  }
  padding: 8px 16px;
`;
